import { iots } from '@code-expert/prelude';
import { CourseUrl, SemesterId, TaskId } from '/imports/domain';
import { end, formatRoute, lit, query, type, url } from '/imports/modules/Routing';
import { messagesSectionQuery } from '/imports/ui/pages/myCourses/messages/navigation';

export const mycoursesSlug = 'mycourses';

const myCourses = lit(mycoursesSlug);
const semester = type('semester', SemesterId);
const courseUrl = type('courseUrl', CourseUrl);

export const myCoursesRoute = url(myCourses, end);
export const courseRoute = url(myCourses, semester, courseUrl, end);

const base = url(myCourses, semester, courseUrl);

export const pageKeys = {
  analytics: null,
  appointments: null,
  backup: null,
  codeExamples: null,
  exercises: null,
  groups: null,
  invitations: null,
  ltiGrading: null,
  messages: null,
  regrade: null,
  settings: null,
  students: null,
};

export type Page = keyof typeof pageKeys;
const page = (p: Page) => url(base, lit(p));

//--------------------------------------------------------------------------------------------------

const analyticsSectionKeys = {
  groupAnalytics: null,
  groupOverview: null,
  jobFrequency: null,
  jobPerTask: null,
  highscore: null,
  data: null,
  submissions: null,
  presentations: null,
};

export type AnalyticsSection = keyof typeof analyticsSectionKeys;

const analyticsSection = iots.exact(
  iots.partial({
    section: iots.keyof(analyticsSectionKeys),
    highscoreChartSection: iots.string,
  }),
);

export const analyticsRoute = url(base, lit('analytics'), query(analyticsSection), end);

//--------------------------------------------------------------------------------------------------

export const appointmentsRoute = url(page('appointments'), end);
export const backupRoute = url(page('backup'), end);
export const codeExamplesRoute = url(page('codeExamples'), end);
export const exercisesRoute = url(page('exercises'), end);

//--------------------------------------------------------------------------------------------------

const groupsSectionKeys = {
  overview: null,
  import: null,
};

export type GroupsSection = keyof typeof groupsSectionKeys;

const groupsSection = iots.exact(iots.partial({ section: iots.keyof(groupsSectionKeys) }));

export const groupsRoute = url(page('groups'), query(groupsSection), end);

//--------------------------------------------------------------------------------------------------

const listInvitationsSectionKeys = {
  pending: null,
  archive: null,
};

export type ListInvitationsSection = keyof typeof listInvitationsSectionKeys;

const ListInvitationsSection: iots.Type<ListInvitationsSection> = iots.keyof(
  listInvitationsSectionKeys,
);

export const listInvitationsRoute = url(
  page('invitations'),
  type('section', ListInvitationsSection),
  end,
);

//--------------------------------------------------------------------------------------------------

export const ltiGradingRoute = url(page('ltiGrading'), end);
export const messagesRoute = url(page('messages'), messagesSectionQuery, end);
export const regradeRoute = url(page('regrade'), end);
export const regradeTaskRoute = url(page('regrade'), type('taskId', TaskId), end);
export const settingsRoute = url(page('settings'), end);
export const studentsRoute = url(page('students'), end);

export const analyticsLink = formatRoute(analyticsRoute);
export const messagesLink = formatRoute(messagesRoute);
